import { render, staticRenderFns } from "./stadium260.vue?vue&type=template&id=ece2051e&"
import script from "./stadium260.vue?vue&type=script&lang=ts&"
export * from "./stadium260.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports